import {
    GET_LIST_PRODUCT_STATUS,
    UPDATE_SPECIFIC_PRODUCT_STATUS,
    CREATE_NEW_PRODUCT_STATUS,
    REMOVE_PRODUCT_STATUS,
    GET_PRODUCT_STATUS_ACTIVE
} from '@/redux/actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    productStatusList: [],
    productStatusActiveList: [],
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_PRODUCT_STATUS: {
            return {
                ...state,
                productStatusList: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }
        case GET_PRODUCT_STATUS_ACTIVE: {
            return {
                ...state,
                productStatusActiveList: action.payload.data,
            }
        }
        case CREATE_NEW_PRODUCT_STATUS: {
            return {
                ...state,
                productStatusList: [action.payload, ...state.productStatusList],
                total: state.total + 1
            }
        }
        case UPDATE_SPECIFIC_PRODUCT_STATUS: {
            let index = state.productStatusList.findIndex((item) => {
                return item.id == action.payload.id;
            });
            let temp = [...state.productStatusList];
            temp[index] = action.payload;
            return { ...state, productStatusList: temp }
        }
        case REMOVE_PRODUCT_STATUS: {
            let temp = state.productStatusList.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });
            return { ...state, productStatusList: temp }
        }
        default: return { ...state };
    }
}
